import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SharedModule as PrimeTemplateModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Router } from '@angular/router';
import { AppUpdateService } from '../../app-update.service';
import { PermissionsService } from '../../permissions.service';

/**
 * Aviso global de versión nueva. `update_available` muestra una barra que se puede
 * cerrar; `update_required` bloquea con un diálogo hasta recargar.
 *
 * Quien administra las versiones puede saltarse el bloqueo: si registró por error una
 * versión obligatoria que todavía no está desplegada, necesita llegar a la pantalla de
 * versiones para corregirlo.
 */
@Component({
    selector: 'app-update-notice',
    standalone: true,
    imports: [NgIf, AsyncPipe, ButtonModule, DialogModule, PrimeTemplateModule],
    templateUrl: './app-update-notice.component.html',
    styleUrls: ['./app-update-notice.component.scss'],
})
export class AppUpdateNoticeComponent {
    private readonly appUpdateService = inject(AppUpdateService);
    private readonly permissionsService = inject(PermissionsService);
    private readonly router = inject(Router);

    dismissed = false;
    reloading = false;
    bypassed = false;

    get canBypass(): boolean {
        return this.permissionsService.hasPermission('ManageAppVersions');
    }

    readonly state$ = this.appUpdateService.state$;

    reload(): void {
        this.reloading = true;
        void this.appUpdateService.reloadToLatest();
    }

    goToReleases(): void {
        this.bypassed = true;
        void this.router.navigate(['/admin/app-releases']);
    }
}
